import { PropTypes } from 'prop-types';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import React from 'react';

const Breadcrumbs = ({ items }) => {
	return (
		<div className={'grid_one'}>
			<Breadcrumb listClassName="breadcrumb-chevron">
				{items.map((item, index) => (
					<BreadcrumbItem
						key={index}
						className="align-items-center"
						active={item.active}
						style={{ paddingTop: item.active && '3px' }}
					>
						{item.link ? (
							<a
								className="font-weight-light font-large-1"
								href={item.link}
								style={{ color: '#00852A' }}
							>
								{item.label}
							</a>
						) : (
							<span
								className="font-weight-bolder font-medium-5"
								style={{ color: '#002575' }}
							>
								{item.label}
							</span>
						)}
					</BreadcrumbItem>
				))}
			</Breadcrumb>
		</div>
	);
};

Breadcrumbs.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			link: PropTypes.string.nullable,
			active: PropTypes.bool.nullable
		})
	)
};
export default Breadcrumbs;
